import * as React from 'react';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import './surveySubmitButton.module.scss';

export const SurveySubmitButton = ({ children, id = undefined, loading, disabled, success, onClick }) => (
  <Button
    id={id}
    styleName="survey-submit-button"
    type={success ? 'success' : 'primary'}
    size="l"
    loading={loading}
    disabled={disabled}
    onClick={!success ? onClick : undefined}
  >
    {children}
  </Button>
);
